<template>
  <v-row no-gutters>
    <v-tooltip bottom v-if="tooltip">
      <template v-slot:activator="{ on, attrs }">
        <v-textarea
            v-bind="$attrs"
            :value="value"
            :outlined="outlined"
            dense
            :clearable="clearable"
            @input="$emit('input', $event !== '' ? $event : null)"
            :error="error"
            :error-messages="error_message"
            :no-resize="noResize"
            :hide-details="!property_state_field_name"
            v-on="on"
        >
        </v-textarea>
      </template>
      <span>{{ value }}</span>
    </v-tooltip>
    <v-textarea
        v-if="!tooltip"
        v-bind="$attrs"
        :value="value"
        :outlined="outlined"
        dense
        :clearable="clearable"
        @input="$emit('input', $event !== '' ? $event : null)"
        :error="error"
        :error-messages="error_message"
        :no-resize="noResize"
        :hide-details="!property_state_field_name"
    >
    </v-textarea>
  </v-row>
</template>

<script>

export default {
  name: 'BaseFieldText',
  inheritAttrs: false,
  props: {
    value: {},
    property_state: {default: null},
    property_state_field_name: {default: null},
    clearable: {default: false},
    outlined: {default: true},
    noResize: {default: true},
    tooltip: {default: false},
  },

  components: {},

  computed: {
    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
      else
        return null
    },
  },

  methods: {},

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
